<template>
  <div class="mt-5">
    <vx-card>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <vs-input
              :label-placeholder="$t('factoryname')"
              v-model="factory.CompanyName"
              class="w-full mb-base"
            />
            <vs-input
              :label-placeholder="$t('companytitle')"
              v-model="factory.CompanyLastName"
              class="w-full mb-base"
            />
            <vs-input
              :label-placeholder="$t('factoryslogan')"
              v-model="factory.Slogan"
              class="w-full mb-base"
            />
            <vs-input
              :label-placeholder="$t('email')"
              v-model="factory.Email"
              class="w-full mb-base"
            />
          </div>
          <div class="col-md-6">
            <vs-input
              :label-placeholder="$t('phone')"
              v-model="factory.Phone"
              class="w-full mb-base"
            />
            <vs-input
              :label-placeholder="$t('address')"
              v-model="factory.Address"
              class="w-full mb-base"
            />
            <vs-input
              :label-placeholder="$t('weburl')"
              v-model="factory.Web"
              class="w-full mb-base"
            />
            <div class="row justify-content-center align-items-center">
              <vs-button @click="saveInfos" class="w-50">{{$t('save')}}</vs-button>
            </div>
          </div>
        </div>
        <div class="row justify-content-space-between">
          <div class="col-md-3">
            <vs-upload
              :headers="header"
              fileName="file"
              automatic
              :limit="1"
              action="https://api.360photoboxcloud.com/api/files/Upload"
              @on-success="successUpload"
            />
            <!-- <label
              class="btn mt-3"
              style="background-color:#7367F0;color:white;border-radius:15px;"
            >
              <i class="fa fa-image"></i>
              {{$t('selectPhoto')}}
              <input
                style="display: none;"
                id="uploader"
                accept=".jpg, .png, .jpeg, .webp"
                type="file"
                :name="$t('selectPhoto')"
                v-on:change="upload"
              />
            </label>-->
          </div>
          <div class="col-md-9">
            <img height="200px" :src="companyPicture" alt />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  data() {
    return {
      header: {
        Authorization: `Bearer ` + this.$store.state.token,
        "Accept-Language": navigator.language,
      },
      factory: {
        CompanyName: "",
        CompanyLastName: "",
        Email: "",
        Phone: "",
        Address: "",
        Web: "",
        Slogan: "",
        LogoFileId: "",
      },
      companyPicture: "",
    };
  },
  methods: {
    /*upload(event) {
      const filereader = new FileReader();
      var _this = this;
      filereader.onload = function (e) {
        _this.companyPicture = e.target.result;
      };
      filereader.readAsDataURL(event.target.files[0]);
    },*/
    successUpload(response) {
      this.$vs.loading();
      let data = JSON.parse(response.currentTarget.response);
      this.factory.LogoFileId = parseInt(data.data.id);
      this.companyPicture = "https://api.360photoboxcloud.com/" + data.data.fileName;
      this.saveInfos();
    },
    saveInfos() {
      let path = "/CompanyInformations/update";
      http.post(path, this.factory).then((response) => {
        notify.success(this.$t("saved"));
      });
    },
    getData() {
      let path = "/CompanyInformations/getbyrequestuserid";
      http.get(path).then((response) => {
        this.factory.CompanyName = response.companyName;
        this.factory.CompanyLastName = response.companyLastname;
        this.factory.Email = response.email;
        this.factory.Phone = response.phone;
        this.factory.Address = response.address;
        this.factory.Web = response.web;
        this.factory.Slogan = response.slogan;
        this.factory.LogoFileId = parseInt(response.logoFileId);
        this.companyPicture =
          "https://api.360photoboxcloud.com/" + response.logoFileName;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
input[type="file"] {
  cursor: pointer !important;
  font: 300 14px sans-serif;
  color: #9e9e9e;
}
input[type="file"]::-webkit-file-upload-button {
  font: 300 14px sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
  border-radius: 30px;
}

input[type="file"]::-ms-browse {
  font: 300 14px "Roboto", sans-serif;
  background: #7367f0;
  border: 0;
  padding: 12px 25px;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
}
</style>